module.exports = __webpack_public_path__ + "static/img/banner-csr-08.3b1f930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-08.jpg
// module id = S5tp
// module chunks = 99